import { HttpClient } from "@/App/services/HttpClient";
import { CASE_ENDPOINTS } from "@/Case/config";
import { Storage } from "@/App/services/LocalStorage";
import { generateStorageKey } from "@/CaseFeedback/store/storageKeyGenerator";

class CaseFeedbackService {
  sendFeedback(caseId: string, rating: number, notes: string): Promise<void> {
    return HttpClient.post(CASE_ENDPOINTS.FEEDBACK(caseId), {
      rating,
      notes,
      type: "ems",
    });
  }

  saveDoNotDisturbPreference(userId: string | undefined, shouldNotDisturb) {
    if (userId) {
      Storage.setItem(generateStorageKey(userId), JSON.stringify(shouldNotDisturb));
    }
  }

  readDoNotDisturbPreference(userId: string | undefined): boolean {
    if (userId) {
      return JSON.parse(Storage.getItem(generateStorageKey(userId)) ?? "false");
    }
    return false;
  }
}

export default new CaseFeedbackService();
